export default {"src":"/_next/static/media/pattern.1c71f61d.svg","height":800,"width":1422,"blurWidth":0,"blurHeight":0};